import * as Rx from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Collections } from '../collections.model';
import { BackendErrorResponse, BackendResponse, StoreBackend } from './backend';
import { Reference } from './store.model';

export class ObjectObservable<
  K extends keyof Collections
> extends Rx.Observable<Collections[K]> {
  constructor(
    private ref$: Rx.Observable<
      Reference<K> & { readonly path: { readonly ids: [string] } }
    >, // The path needs to have a single entry in `ids`.
    private storeBackend: StoreBackend,
    public errors$: Rx.Observable<BackendErrorResponse>,
    source: Rx.Observable<Collections[K]>,
  ) {
    super();
    this.source = source;
  }

  set(object: Collections[K]): Promise<BackendResponse> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref => this.storeBackend.set(ref, ref.path.ids[0], object)),
      )
      .toPromise();
  }

  update(object: Partial<Collections[K]>): Promise<BackendResponse> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref =>
          this.storeBackend.update(ref, ref.path.ids[0], object),
        ),
      )
      .toPromise();
  }

  remove(): Promise<BackendResponse> {
    return this.ref$
      .pipe(
        take(1),
        switchMap(ref => this.storeBackend.delete(ref, ref.path.ids[0])),
      )
      .toPromise();
  }
}
